import { render, staticRenderFns } from "./historyAnalyCard.vue?vue&type=template&id=6ef10c8e&scoped=true&"
import script from "./historyAnalyCard.vue?vue&type=script&lang=js&"
export * from "./historyAnalyCard.vue?vue&type=script&lang=js&"
import style0 from "./historyAnalyCard.vue?vue&type=style&index=0&id=6ef10c8e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef10c8e",
  null
  
)

export default component.exports